"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LastCalled = exports.ViewMode = void 0;
const react_1 = __importDefault(require("react"));
var ViewMode;
(function (ViewMode) {
    ViewMode["Rectangular"] = "rectangular";
    ViewMode["Bar"] = "bar";
    ViewMode["None"] = "none";
})(ViewMode = exports.ViewMode || (exports.ViewMode = {}));
const LastCalled = ({ items: items, viewMode = ViewMode.None, }) => {
    const numberElement = (items) => {
        if (!items.length) {
            return null;
        }
        return (react_1.default.createElement("div", { className: "dqm-lcc-last-called" },
            react_1.default.createElement("div", { className: "dqm-lcc-last-called__heading" }, "Palveluvuorossa:"),
            items.map((item, i) => (react_1.default.createElement("div", { key: `dqm-lcc-number-${i}`, className: "dqm-lcc-last-called__item" },
                react_1.default.createElement("span", null, item.title))))));
    };
    const helperElement = (visible) => {
        if (!visible) {
            return null;
        }
        return (react_1.default.createElement("div", { className: "dqm-lcc-helper" },
            react_1.default.createElement("h2", { className: "dqm-lcc-helper__heading" }, "Ole hyv\u00E4 ja ota vuoronumero")));
    };
    const viewModeClass = `dqm-lcc-container--viewmode--${viewMode}`;
    return (react_1.default.createElement("div", { className: `dqm-lcc-container ${viewModeClass}` },
        numberElement(items),
        helperElement(!items.length)));
};
exports.LastCalled = LastCalled;
//# sourceMappingURL=LastCalled.js.map